import { render, staticRenderFns } from "./ExaminationRecords.vue?vue&type=template&id=302cd5ee&scoped=true&"
import script from "./ExaminationRecords.vue?vue&type=script&lang=js&"
export * from "./ExaminationRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302cd5ee",
  null
  
)

export default component.exports